import { ContattiUtenti } from 'app/model/contatti';
import { IContatto } from 'app/model/contatto';
import { NgbModal, NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Component } from '@angular/core';
import { NewContactComponent } from 'app/rubrica/newContact/newContact';
import { ChangeComponent } from 'app/rubrica/changeCategory/change';
import { ConfirmationComponent } from 'app/home/sidebar/confirmation/confirmation';
import { MeasureService } from 'app/measure.service';
import { SEARCH_FUNCTION_TOKEN, ISearch } from 'app/components/search/search.component';
import { search } from 'app/ricerca.soggetti';

@Component({
	selector: 'app-rubrica',
	templateUrl: './rubrica.html',
	styleUrls: ['./rubrica.css'],
	providers: [
		{
			provide: SEARCH_FUNCTION_TOKEN,
			useExisting: RubricaComponent
		}
	]
})
export class RubricaComponent implements ISearch<IContatto> {

	filteredContacts: IContatto[];
	page: IContatto[];
	mobileView: number;

	pending: Promise<any> = Promise.resolve(true);

	constructor(
		private readonly modalService: NgbModal,
		readonly contatti: ContattiUtenti,
		measureService: MeasureService
	) {
		this.mobileView = measureService.isMobile() ? 1 : 3;
	}

	deleteContact(value: IContatto) {
		const modalRef = this.modalService.open(ConfirmationComponent);
		modalRef.componentInstance.setElementoDaCancellare(value.nome);
		modalRef.result
			.then(() => {
				this.pending = this.contatti.delete(value);
			})
			// Non faccio nulla se l'utente decide di non cancellare
			.catch(() => { });
	}

	updateContact(value: IContatto, update) {
		this.contatti.update(Object.assign({}, value, update));
	}

	addContact() {
		const modalRef = this.modalService.open(NewContactComponent);
		modalRef.result.then(
			(contact: IContatto) => this.contatti.add(contact),
			() => { }
		);
	}

	search(key: string, contatti: IContatto[]) {
		return search(key, contatti, contatto => contatto);
	}

	changeCategory(value: IContatto) {
		const modalRef = this.modalService.open(ChangeComponent);
		modalRef.componentInstance.setCategory(value.categoria);
		modalRef.result.then(
			(cat: string) => this.contatti.update(Object.assign({}, value, { categoria: cat })),
			() => { }
		);
	}

	valid(value: IContatto) {
		return value.indirizzo && value.numciv && value.citta;
	}

	contactTabChanged(contatto: IContatto, $event: NgbTabChangeEvent) {
		contatto['selectedTab'] = $event.nextId;
	}
}



// WEBPACK FOOTER //
// ./src/app/rubrica/rubrica.ts